import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Form, Spinner } from "react-bootstrap";
import "./index.css";
import { MenuCategory, MenuItem } from "../../../redux/menuSlice";
import { useLazyGetMenuItemsByRestaurantIdQuery } from "../../../redux/services/menuItemService";
import { Link } from "react-router-dom";
import ButtonComponent from "../../../components/ButtonComponent";
import { Col, Row } from "reactstrap";

const RegularOverView = () => {
  const restaurantId = localStorage.getItem("selectedRestaurantId") || "";
  const [selectedCategory, setSelectedCategory] = useState("");

  const [trigger, { data: menuItems, isLoading, isError, error }] =
    useLazyGetMenuItemsByRestaurantIdQuery();

  useEffect(() => {
    if (restaurantId) {
      trigger(restaurantId);
    }
  }, [restaurantId, trigger]);

  if (isError) {
    let e: any = error;
    if (e.status === 404) {

    }
    if (e.status === 500) {
      console.error("Something Went Wrong");
    }
  }

  const handleCategoryChange = (e: any) => {
    setSelectedCategory(e.target.value);
  };

  const hasMenuItems = menuItems && menuItems.length > 0;

  return (
    <div className="regular-overview-whole-component-left">
      <div style={{ margin: "0.5% 19%" }}>
        <Link
          to={`/menu/regular/items/add-item`}
          style={{ textDecoration: "none" }}
          onClick={(e) => e.stopPropagation()}
        >
          <ButtonComponent titel="Add Menu Items" />
        </Link>
      </div>

      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "200px" }}
        >
          <Spinner animation="border" variant="primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <span className="ms-2">Please wait, Menu Items are Loading</span>
        </div>
      ) : hasMenuItems ? (
        <>
          <div className="regular-overview-top-title">
            <Form.Group controlId="categorySelect">
              <Form.Label>
                <b>Select Category</b>
              </Form.Label>
              <Form.Control
                as="select"
                value={selectedCategory}
                onChange={handleCategoryChange}
              >
                <option value="">All Categories</option>
                {menuItems.map((menuCategory: any) => (
                  <option
                    key={menuCategory.category}
                    value={menuCategory.category}
                  >
                    {menuCategory.category}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </div>

          <div>
            {menuItems.map((menuCategory: MenuCategory) => {
              if (
                selectedCategory === "" ||
                selectedCategory === menuCategory.category
              ) {
                return (
                  <Card
                    key={menuCategory.category}
                    className="Regular-Overview-first-card"
                  >
                    <CardHeader className="Regular-Overview-first-card-header">
                      <h2>{menuCategory.category}</h2>
                    </CardHeader>
                    <CardBody>
                      {(menuCategory.items || []).map((item: MenuItem) => (
                        <div key={item.id}>
                          <Row
                            style={{
                              borderBottom: "1px solid #bdc5cc",
                              marginBottom: "2%",
                              paddingBottom: "2%",
                            }}
                          >
                            <Col lg="2">
                              <img
                                src={item.imageUrl[0]}
                                alt="pizzaphoto"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                }}
                              />
                            </Col>
                            <Col lg="6">
                              <h4>{item.displayName}</h4>
                              <p>{item.description}</p>
                            </Col>
                            <Col lg="4">
                              <div style={{ position: "relative" }}>
                                <span
                                  style={{
                                    position: "absolute",
                                    left: "5%",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#6c757d",
                                    pointerEvents: "none",
                                  }}
                                >
                                  LKR
                                </span>
                                <input
                                  type="number"
                                  required
                                  value={item.price}
                                  style={{
                                    border: "1px solid #E3E8EF",
                                    borderRadius: "5px",
                                    width: "100%",
                                    height: "2.5rem",
                                    paddingLeft: "70%",
                                  }}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </CardBody>
                  </Card>
                );
              }
              return null;
            })}
          </div>
        </>
      ) : (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "200px" }}
        >
          <h5>No data available</h5>
        </div>
      )}
    </div>
  );
};

export default RegularOverView;
